﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class DriverClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    getAll() {
        return this.client.apiDriversGet();
    }
    get(key) {
        return this.client.apiDriversByIdGet(key);
    }
    getEditable() {
        return this.client.apiDriversEditableGet();
    }
    create(driver) {
        return this.client.apiDriversPost(driver);
    }
    createFromExistingUser(driver) {
        return this.client.apiDriversFromuserPost(driver);
    }
    update(key, driver) {
        return this.client.apiDriversByIdPut(key, driver);
    }
    delete(data) {
        return this.client.apiDriversDelete(data);
    }
}
exports.DriverClient = DriverClient;
//# sourceMappingURL=DriverClient.js.map